import React, { useState, useEffect } from "react";

import BarChart from "../../../common/BarChart";

const BarChartCard = ({ data }) => {
  const [currentChart, setCurrentChart] = useState({
    path: "payable",
    label: "قابل پرداخت",
  });

  const [chartData, setChartData] = useState([
    { label: "مصارف", color: "#075da9", value: 0 },
    { label: "درآمد", color: "#075da9", value: 0 },
  ]);

  const chartFilterBtns = [
    {
      path: "payable",
      label: "قابل پرداخت",
    },
    {
      path: "paid",
      label: "پرداخت شده",
    },
    {
      path: "balance",
      label: "باقی مانده",
    },
  ];

  useEffect(() => {
    data?.expenses &&
      setChartData([
        {
          label: "مصارف",
          color: "#075da9",
          value: data?.expensesSummary[currentChart.path] || 0,
        },
        {
          label: "درآمد",
          color: "#075da9",
          value: data?.revenuesSummary[currentChart.path] || 0,
        },
      ]);
  }, [currentChart, data]);

  return (
    <React.Fragment>
      <div className="barChart-toggle-data">
        {chartFilterBtns.map((btn) => (
          <button
            key={btn.path}
            onClick={() => setCurrentChart(btn)}
            className={btn.path === currentChart.path ? "active" : ""}
          >
            {btn.label}
          </button>
        ))}
      </div>
      <div className="barChart-wrapper">
        <BarChart data={chartData} />
      </div>
      <div className="barChart-total">
        <ul>
          <li>
            <span>درآمد</span>
            <b>{chartData[1]?.value}</b>
          </li>
          <li>
            <span>مصرف</span>
            <b>{chartData[0]?.value}</b>
          </li>
          <li>
            <span>تفاوت</span>
            <b>{(chartData[1]?.value - chartData[0]?.value).toFixed(2)}</b>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default BarChartCard;
